import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';

export const SearchHeader = ({ filters, setFilters, setGlobalFilterValue, globalFilterValue, inactiveOnly, onInactiveOnlyChange }) => {

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const clearFilter = () => {
        let _filters = { ...filters };

        _filters['global'].value = "";
        setFilters(_filters);
        setGlobalFilterValue("");
    };

    return (
        <div className="asset-detail-toolbar">
            <span className="inactive-filter">
                <Checkbox
                    inputId="inactive-sensors"
                    checked={!!inactiveOnly}
                    onChange={(event) => onInactiveOnlyChange(event.checked)}
                />
                <label htmlFor="inactive-sensors">Inactive</label>
                <i
                    className="pi pi-info-circle inactive-filter-info"
                    aria-label="Displays only inactive devices"
                />
                <Tooltip target=".inactive-filter-info" content="A sensor may become inactive when a tracker loses network connectivity due to tunnels, obstructed buildings, or moving outside network coverage." position="bottom" />
            </span>
            <span className="p-input-icon-left p-input-clear-icon-right">
                <i className="pi pi-search" />
                <InputText
                    value={globalFilterValue}
                    onChange={onGlobalFilterChange}
                    placeholder="Keyword Search"
                />
                {globalFilterValue && (
                    <Button
                        type="button"
                        icon="pi pi-times"
                        className="p-button-text p-clear-button"
                        onClick={clearFilter}
                    />
                )}
            </span>
        </div>
    );
};
